import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const TAURI_EVENT_LISTEN_ACL_REJECTION =
  'command plugin:event|listen not allowed by acl';
const WRAPPED_TAURI_EVENT_LISTEN_ACL_REJECTION = `non-error promise rejection captured with value: ${TAURI_EVENT_LISTEN_ACL_REJECTION}`;

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

const isExpectedTauriEventListenAclRejection = (message: unknown): boolean => {
  const normalizedMessage = toNormalizedMessage(message);

  return (
    normalizedMessage === TAURI_EVENT_LISTEN_ACL_REJECTION ||
    normalizedMessage === WRAPPED_TAURI_EVENT_LISTEN_ACL_REJECTION
  );
};

export const nonErrorTauriEventListenAclUnhandledRejectionRule: ClientSentryIgnoreRule =
  {
    id: 'non-error-tauri-event-listen-acl-unhandled-rejection',
    references: ['FTR-3163'],
    reason:
      'Known external Tauri webview rejection without usable seller-ui stack/app-frame context',
    matches: (context) => {
      if (context.firstExceptionType !== 'UnhandledRejection') {
        return false;
      }

      if (hasActionableContext(context)) {
        return false;
      }

      return (
        isExpectedTauriEventListenAclRejection(context.serializedMessage) ||
        isExpectedTauriEventListenAclRejection(context.originalExceptionMessage)
      );
    },
  };
